const UpDownArrowIcon = ({
  direction = 'up',
  className = 'h-[15px] w-[15px]',
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="black"
    className={className}
  >
    {direction === 'up' ? (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 6l-6 6m6-6l6 6M12 6v12"
      />
    ) : (
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M12 18l6-6m-6 6l-6-6M12 18V6"
      />
    )}
  </svg>
);

export default UpDownArrowIcon;
